import styled from 'styled-components';
import { Color } from '../../common/base';

const Wrapper = styled.div`
  background-image: ${({ theme: { colors } }) =>
    `linear-gradient(to bottom, ${colors.light.primary}, ${colors.gray.light})`};
  padding-bottom: 100px;
`;

const Title = styled.div`
  padding-top: 100px;
  border-top: 1px solid ${Color.greyDark};
  margin-bottom: 0px;
`;

export { Wrapper, Title };
